export class LeagueDivisionsFiltersRequest {
  league_id: number = null;
  end_date_min_timestamp: number = null;
  end_date_max_timestamp: number = null;
}
